import React from 'react';

const Footer = () => {
    return (
        <div style={{backgroundColor:'#000',color:'#fff',padding:'20px',display:'flex',alignItems:'center',justifyContent:'center',marginTop:'40px'}}>
            <p style={{marginBottom:'0'}}>Design and build by Somiya Khan Prity</p>
        </div>
    );
};

export default Footer;